import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.BFF_URL;

class AppointmentSlotService {
  getAvailableSlots(businessId, resourceId, startDate, endDate, page = 1, size = 100) {
    return axios.get(`${API_URL}/v1/slots`, {
      params: {
        businessId,
        resourceId,
        available: true,
        startDate,
        endDate,
        page,
        size
      },
      headers: authHeader()
    });
  }
}

export default new AppointmentSlotService();



// WEBPACK FOOTER //
// ./src/service/appointment-slot.service.js